const keys = {
	GOOGLE_PLACE_API_KEY: 'AIzaSyB30wwHlOOh6ytKbkYZKiQx4JQ33LqLEwg',
	GEOCODER_API_KEY: 'AIzaSyDhGhfm_iRJKo89UfC-e9ov4yu29_YqJZg',
};

export default keys;
